import ManageTestsTable from './ManageTestsTable'

export default ManageTestsTable;